module.exports = __webpack_public_path__ + "media/images/lb/915-c0e9522c3cca0baab7ceb7c820d22d27.svg";